<div *ngIf="showCard()" class="aggregate-card--expansion-container">
    <forge-expansion-panel (forge-expansion-panel-toggle)="expandAggregate($event)"
                           [attr.telemetry]="aggregateProviderId">

        <forge-toolbar slot="header" style="position: relative;" tabindex="0" role="button">
            <forge-icon slot="before-start" *ngIf="getIcon()" [name]="getIcon()" [ngClass]="iconClass"
                        class="aggregate-card--icon">
            </forge-icon>

            <div slot="start" fxLayout="column" fxLayoutAlign="start start">
                <div class="forge-typography--heading2 aggregate-card--header">
                    {{aggregate.Name}} ({{aggregateCount}})
                </div>
                <div class="forge-typography--subheading1 aggregate-card--header-summary">
                    {{summary}}
                </div>
            </div>

            <tt-card-header-action *ngIf="showCardCommands" slot="end" layout-column>
                <command-menu [commands]="cardCommands" icon="more_vert" telemetry="Edit-CardCommands">
                </command-menu>
            </tt-card-header-action>

            <div slot="end" *ngIf="hasCardActions" fxLayout="row" fxLayoutAlign="end center">
                <div *ngFor="let action of aggregate.CardActions">
                    <forge-button *ngIf="isTextButton(action)" dense (click)="cardActionClicked(action, $event)"
                                  [aria-label]="getAriaLabelForCardAction(action)">

                        {{action.label}}
                    </forge-button>

                    <forge-icon-button dense (click)="cardActionClicked(action, $event)"
                                       [aria-label]="getAriaLabelForCardAction(action)">
                        <forge-tooltip>{{action.label}}</forge-tooltip>
                        <forge-icon [name]="action.icon"></forge-icon>
                    </forge-icon-button>
                </div>
            </div>

            <forge-open-icon class="aggregate-card--open-icon" slot="after-end"></forge-open-icon>

            <forge-focus-indicator inward focus-mode="focus"></forge-focus-indicator>
            <forge-state-layer></forge-state-layer>
        </forge-toolbar>

        <div class="aggregate-card--detail" style="visibility: collapse;">
            <div style="outline:none;" telemetry="Submission-StopPropagation">
                <ng-container *ngFor="let cardData of shownCards; let last = last;">
                    <card-elements [aggregate]="aggregate" [cardData]="cardData"
                                   [chartConfiguration]="chartConfiguration" [color]="color"
                                   (reloadAggregate)="onReloadAggregate($event)"
                                   (actionPerformedEvent)="handleCardAction($event)" class="no-pointer">
                    </card-elements>
                    <forge-divider></forge-divider>
                </ng-container>

                <div *ngIf="subAggregates">
                    <aggregate-collection [aggregates]="subAggregates"
                                          (actionPerformedEvent)="handleCardAction($event)">
                    </aggregate-collection>
                </div>

            </div>
            <div>
                <forge-linear-progress *ngIf="isLoadingCards"></forge-linear-progress>

                <div *ngIf="canShowMore" fxLayout="column" fxLayoutAlign="center center">
                    <forge-icon-button dense (click)="showMore($event)" aria-label="Show more">
                        <forge-tooltip>Show more</forge-tooltip>
                        <forge-icon name="chevron_double_down"></forge-icon>
                    </forge-icon-button>
                    <forge-divider style="width: 100%;"></forge-divider>
                </div>
            </div>
        </div>
    </forge-expansion-panel>

    <a #downloadAnchor fxHide></a>
</div>